// extracted by mini-css-extract-plugin
module.exports = {"preFooter":"PreFooter_preFooter__31FRU","contentWrapper":"PreFooter_contentWrapper__1cGTf","disabled":"PreFooter_disabled__NYM6i"};